import {
  GET_MEDICAL_INVENTORY,
  MEDICAL_INVENTORY_ERROR,
  SHOW_MEDICAL_INVENTORY_LOADING,
  SHOW_EDIT_MEDICAL_INVENTORY_LOADING,
  CREATE_MEDICAL_INVENTORY,
  EDIT_MEDICAL_INVENTORY,
  DELETE_MEDICAL_INVENTORY,
  SHOW_DELETE_MEDICAL_INVENTORY_LOADING,
  UPLOAD_MEDICAL_INVENTORY_CSV,
} from '../actions/types';

/**
 *
 */

const initialState = {
  medicalinventorylist: [],
  medicalinventorydetails: null,
  inventoryLoading: false,
  editloading: false,
  deleteLoading: false,
  error: {},
};

export default function medicalInventoryReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_MEDICAL_INVENTORY_LOADING:
      return {
        ...state,
        inventoryLoading: true,
      };
    case SHOW_EDIT_MEDICAL_INVENTORY_LOADING:
      return {
        ...state,
        editloading: true,
      };
    case SHOW_DELETE_MEDICAL_INVENTORY_LOADING:
      return {
        ...state,
        deleteLoading: true,
      };
    case GET_MEDICAL_INVENTORY:
      return {
        ...state,
        medicalinventorylist: payload,
        inventoryLoading: false,
      };
    case CREATE_MEDICAL_INVENTORY:
      return {
        ...state,
        medicalinventorylist: [payload, ...state.medicalinventorylist],
        editloading: false,
      };
    case EDIT_MEDICAL_INVENTORY:
      return {
        ...state,
        medicalinventorylist: state.medicalinventorylist.map((inventory) =>
          inventory._id === payload._id
            ? {
                ...inventory,
                name: payload.name,
                category: payload.category,
                subCategory: payload.subCategory,
                quantity: payload.quantity,
                totalAmount: payload.totalAmount,
                locationID: payload.locationID,
                locationBox: payload.locationBox,
                description: payload.description,
                expDate: payload.expDate,
                department: payload.department,
              }
            : inventory
        ),
        editloading: false,
      };

    case DELETE_MEDICAL_INVENTORY:
      return {
        ...state,
        medicalinventorylist: state.medicalinventorylist.filter(
          (inventory) => inventory._id !== payload
        ),
        deleteLoading: false,
      };

    case UPLOAD_MEDICAL_INVENTORY_CSV:
      return {
        ...state,
        medicalinventorylist: [...payload, ...state.medicalinventorylist],
        inventoryLoading: false,
      };

    case MEDICAL_INVENTORY_ERROR:
      return {
        ...state,
        error: payload,
        inventoryLoading: false,
      };
    default:
      return state;
  }
}
